







































import Vue from 'vue';
import _ from 'lodash';
import { apolloClient } from '@/graphql';
import gql from 'graphql-tag';
import GetMotmData from '../../graphql/leagues/GetMotmData.gql';

export default Vue.extend({
	name: 'MOTMTable',

	props: {
		selectedManOfTheMatch: Object,
		type: String,
	},

	data: () => ({
		motmForLeague: [] as any[],
		motmTable: [] as any[],
		display_name: '',
	}),

	methods: {
		async motmTableCalculate(selectedMatch: any) {
			this.display_name = selectedMatch.name;
			const ids: any[] = [];
			const selectedManOfTheMatchLeagues = selectedMatch.join_league_manofthematch;
			selectedManOfTheMatchLeagues.map((m: any) => {
				ids.push(m.league);
				if (this.type != 'man_of_match') {
					if (m.leagueByLeague && m.leagueByLeague.parentLeagues.length > 0) {
						m.leagueByLeague.parentLeagues &&
							m.leagueByLeague.parentLeagues.length &&
							m.leagueByLeague.parentLeagues.map(({ league }: any) => {
								league.id && ids.push(league.id);
							});
					}
				}
			});
			try {
				(this as any).motmForLeague = await this.getData(ids as any);
				this.CreateMOTMTable(this.motmForLeague);
			} catch (e) {
				return ((this as any).motmForMM = []);
			}
		},

		CreateMOTMTable(MotmData: any) {
			const matches = MotmData;
			if (!matches || !matches.length) return [];
			const manOfTheMatch: any = [];
			matches &&
				matches.length &&
				matches.forEach((match: any) => {
					if (!match.man_of_the_match) return;
					const player = match.man_of_the_match;
					let team = '';
					let teamId = null;
					for (let i = 0; i < player.team.length; i++) {
						const t = player.team[i];
						if (t.team === match.homeTeam.id) {
							team = match.homeTeam.name;
							teamId = match.homeTeam.id;
							break;
						}
						if (t.team === match.awayTeam.id) {
							team = match.awayTeam.name;
							teamId = match.awayTeam.id;
							break;
						}
					}
					const motm = {
						playerId: player.id,
						name: player.first_name + ' ' + player.last_name,
						team: team,
						teamId: teamId,
						awards: 1,
					};
					const idtoFind = teamId;
					const isManOfTheMatchExist = manOfTheMatch.findIndex((motm: any) => motm.teamId === idtoFind && player.id === motm.playerId);
					if (isManOfTheMatchExist < 0 || !manOfTheMatch.length) {
						manOfTheMatch.push(motm);
					} else {
						manOfTheMatch[isManOfTheMatchExist] = {
							...manOfTheMatch[isManOfTheMatchExist],
							awards: manOfTheMatch[isManOfTheMatchExist].awards + 1,
						};
					}
				});
			this.motmTable = _.orderBy(manOfTheMatch, ['awards'], ['desc']);
		},

		async getData(ids: []) {
			try {
				const promises = ids.map((id: any) => {
					return apolloClient.query({
						query: GetMotmData,
						fetchPolicy: 'no-cache',
						variables: {
							id,
						},
					});
				});
				const responses = await Promise.all(promises);
				const result: any[] = [];
				responses.map((res: any) => {
					res.data.motmForLeague &&
						res.data.motmForLeague.matches &&
						res.data.motmForLeague.matches.length &&
						res.data.motmForLeague.matches.map((match: any) => result.push(match));
				});
				return result;
			} catch (error) {
				console.log('error is ', error);
				return [];
			}
		},
	},

	mounted() {
		if (Object.entries(this.selectedManOfTheMatch).length !== 0) {
			this.motmTableCalculate(this.selectedManOfTheMatch);
		}
	},
});
